import { render, staticRenderFns } from "./RecipeOrder.vue?vue&type=template&id=50fe8527&scoped=true&"
import script from "./RecipeOrder.vue?vue&type=script&lang=js&"
export * from "./RecipeOrder.vue?vue&type=script&lang=js&"
import style0 from "./RecipeOrder.vue?vue&type=style&index=0&id=50fe8527&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe8527",
  null
  
)

export default component.exports